import "./customer.css"
import personone from "../../img/p1.png"
import persontwo from "../../img/p2.png"
import personthree from "../../img/p3.png"
import personfour from "../../img/p4.png"
import personfive from "../../img/p5.png"
import personsix from "../../img/p6.png"
function Customer(){
    return(
        <>
        <div className="customer">
                     <div className="table">
                   <div className="start">
                       <h4>Customers Avilable </h4>
                       <div className="point">
                           <div></div>
                           <div></div>
                           <div></div>
                       </div>
                   </div>
                   <div className="end">
                       <table className="table table-hover  rounded align-middle">
           <thead> 
             <tr>
                <th>
                    <input type="checkbox" name="" id="" />
                </th>
               <th>Customers</th>
                     <th>Email</th>
       
               <th>Group</th>
               <th>Date</th>
               <th>Phone</th>
               <th>Status</th>

               <th>Actions</th>
             </tr>
           </thead>
           <tbody>

  {/* Row 1 */}
  <tr>
    <td><input type="checkbox" /></td>
    <td><img src={personone} alt="" /></td>
    <td><p>Archie Cantones</p></td>
    <td><p>archie.cantones@gmail.com</p></td>
    <td><button className="btn btn-dark">High Budget</button></td>
    <td>11/06/2023 10:53</td>
    <td>+1 (357) 9632 548</td>
    <td><i className="fa-solid fa-circle" style={{color:"#46da10"}}></i> Active</td>
    <td>
      <i className="fa-solid fa-ellipsis-vertical me-2"></i>
      <i className="fa-solid fa-eye"></i>
    </td>
  </tr>

  {/* Row 2 */}
  <tr>
    <td><input type="checkbox" /></td>
    <td><img src={persontwo} alt="" /></td>
    <td><p>Holmes Cherryman</p></td>
    <td><p>holmes.cherryman@gmail.com</p></td>
    <td><button className="btn btn-warning">Medium Budget</button></td>
    <td>15/06/2023 14:20</td>
    <td>+44 (789) 4561 223</td>
    <td><i className="fa-solid fa-circle" style={{color:"#f0ad4e"}}></i> Pending</td>
    <td>
      <i className="fa-solid fa-ellipsis-vertical me-2"></i>
      <i className="fa-solid fa-eye"></i>
    </td>
  </tr>

  {/* Row 3 */}
  <tr>
    <td><input type="checkbox" /></td>
    <td><img src={personthree} alt="" /></td>
    <td><p>Melanie Hanvey</p></td>
    <td><p>melanie.hanvey@gmail.com</p></td>
    <td><button className="btn btn-success">Low Budget</button></td>
    <td>18/06/2023 09:12</td>
    <td>+20 (102) 3344 556</td>
    <td><i className="fa-solid fa-circle" style={{color:"#46da10"}}></i> Active</td>
    <td>
      <i className="fa-solid fa-ellipsis-vertical me-2"></i>
      <i className="fa-solid fa-eye"></i>
    </td>
  </tr>

  {/* Row 4 */}
  <tr>
    <td><input type="checkbox" /></td>
    <td><img src={personfour} alt="" /></td>
    <td><p>Kenneth Hume</p></td>
    <td><p>kenneth.hume@gmail.com</p></td>
    <td><button className="btn btn-danger">High Budget</button></td>
    <td>20/06/2023 16:45</td>
    <td>+33 (654) 9987 321</td>
    <td><i className="fa-solid fa-circle" style={{color:"#dc3545"}}></i> Inactive</td>
    <td>
      <i className="fa-solid fa-ellipsis-vertical me-2"></i>
      <i className="fa-solid fa-eye"></i>
    </td>
  </tr>

  {/* Row 5 */}
  <tr>
    <td><input type="checkbox" /></td>
    <td><img src={personfive} alt="" /></td>
    <td><p>Sophia Martinez</p></td>
    <td><p>sophia.martinez@gmail.com</p></td>
    <td><button className="btn btn-primary">Medium Budget</button></td>
    <td>25/06/2023 11:30</td>
    <td>+49 (321) 7788 990</td>
    <td><i className="fa-solid fa-circle" style={{color:"#0d6efd"}}></i> Reviewing</td>
    <td>
      <i className="fa-solid fa-ellipsis-vertical me-2"></i>
      <i className="fa-solid fa-eye"></i>
    </td>
  </tr>
   {/* Row 1 */}
  <tr>
    <td><input type="checkbox" /></td>
    <td><img src={personone} alt="" /></td>
    <td><p>Archie Cantones</p></td>
    <td><p>archie.cantones@gmail.com</p></td>
    <td><button className="btn btn-dark">High Budget</button></td>
    <td>11/06/2023 10:53</td>
    <td>+1 (357) 9632 548</td>
    <td><i className="fa-solid fa-circle" style={{color:"#46da10"}}></i> Active</td>
    <td>
      <i className="fa-solid fa-ellipsis-vertical me-2"></i>
      <i className="fa-solid fa-eye"></i>
    </td>
  </tr>

  {/* Row 2 */}
  <tr>
    <td><input type="checkbox" /></td>
    <td><img src={persontwo} alt="" /></td>
    <td><p>Holmes Cherryman</p></td>
    <td><p>holmes.cherryman@gmail.com</p></td>
    <td><button className="btn btn-warning">Medium Budget</button></td>
    <td>15/06/2023 14:20</td>
    <td>+44 (789) 4561 223</td>
    <td><i className="fa-solid fa-circle" style={{color:"#f0ad4e"}}></i> Pending</td>
    <td>
      <i className="fa-solid fa-ellipsis-vertical me-2"></i>
      <i className="fa-solid fa-eye"></i>
    </td>
  </tr>
   {/* Row 4 */}
  <tr>
    <td><input type="checkbox" /></td>
    <td><img src={personfour} alt="" /></td>
    <td><p>Kenneth Hume</p></td>
    <td><p>kenneth.hume@gmail.com</p></td>
    <td><button className="btn btn-danger">High Budget</button></td>
    <td>20/06/2023 16:45</td>
    <td>+33 (654) 9987 321</td>
    <td><i className="fa-solid fa-circle" style={{color:"#dc3545"}}></i> Inactive</td>
    <td>
      <i className="fa-solid fa-ellipsis-vertical me-2"></i>
      <i className="fa-solid fa-eye"></i>
    </td>
  </tr>

  {/* Row 5 */}
  <tr>
    <td><input type="checkbox" /></td>
    <td><img src={personfive} alt="" /></td>
    <td><p>Sophia Martinez</p></td>
    <td><p>sophia.martinez@gmail.com</p></td>
    <td><button className="btn btn-primary">Medium Budget</button></td>
    <td>25/06/2023 11:30</td>
    <td>+49 (321) 7788 990</td>
    <td><i className="fa-solid fa-circle" style={{color:"#0d6efd"}}></i> Reviewing</td>
    <td>
      <i className="fa-solid fa-ellipsis-vertical me-2"></i>
      <i className="fa-solid fa-eye"></i>
    </td>
  </tr>

</tbody>

         </table>
                   </div>
               </div>
               </div>
        </>
    )
}
export default Customer